import { getMediaType } from "./mediaUtils";
import type { Entity, MediaResponse } from "../types";

export const entityIsMedia = (entity: Entity) => {
  if (!entity) return false;
  // getMediaType reads media_kind for API media. A zip or csv ("other") isn't counted:
  // the viewer has nothing to show for it, so it keeps opening the details popup.
  const type = getMediaType(entity as unknown as MediaResponse);
  if (type === "unknown") return false;
  return true;
};
